import styled from 'styled-components';

import { Box } from 'components/Box';
import { bp, gutterWidth } from 'theme';

export const CmsFourArticlesHighlightBlockPageSectionContainer = styled(Box)`
  @media (max-width: ${bp[1] - 1}px) {
    &:not(:first-child) {
      margin-top: ${(gutterWidth * 3) / 4}px;
    }
  }
  @media (min-width: ${bp[1]}px) and (max-width: ${bp[2] - 1}px) {
    &:not(:nth-child(1)):not(:nth-child(2)) {
      margin-top: ${gutterWidth}px;
    }
  }

  a {
    position: relative;
    display: block;
    max-width: 240px;
  }
`;
